import { Injectable } from '@angular/core';
import { find, isEmpty, isEqual, sortedUniq } from 'lodash';
import { CommonRegEx } from '../../validators/match.pattern.validator';

@Injectable()
export class UploadFileService {
  lineNo: number;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  columnName: any;

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  isCSVFile(file: any): any {
    return file.name.endsWith('.csv');
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  validateHeaders(origHeaders: any, fileHeaders: any): any {
    if (origHeaders.length !== fileHeaders.length) {
      return false;
    }
    let fileHeaderMatchFlag = false;
    const origHeadersSorted = sortedUniq(origHeaders);
    const fileHeadersSorted = sortedUniq(fileHeaders);
    if (isEqual(origHeadersSorted, fileHeadersSorted)) {
      fileHeaderMatchFlag = true;
    }
    return fileHeaderMatchFlag;
  }

  getHeaderErrorMessage(fileHeaders: Array<string>, definedHeaders: Array<string>): string {
    const invalidHeader = fileHeaders.find(fileHeader => !definedHeaders.includes(fileHeader));
    if (invalidHeader) {
      return 'Header column name "' + invalidHeader + '" is invalid';
    }
    const missedHeader = definedHeaders.find(header => !fileHeaders.includes(header));
    if (missedHeader) {
      return 'Header column name "' + missedHeader + '" is missing';
    }
    return 'Invaid header column names found';
  }

  validateDataRecordsArrayFromCSVFile(
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    uploadDataSource: any,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    uploadAlternateDataSource: any,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    csvRecordsArray: any,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    headerData: any,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    isHeaderPresent: any
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  ): any {
    let message = null;
    for (let i = 0; i < csvRecordsArray.length; i++) {
      const data = csvRecordsArray[i];
      const headerLength = headerData.length;
      this.lineNo = isHeaderPresent ? i + 2 : i + 1;
      if (data.length !== headerLength) {
        if (isEmpty(data)) {
          message = `Extra blank line is present at line number ${this.lineNo}, please remove it.`;
        } else {
          message = `Record at line number ${this.lineNo} contain ${data.length} tokens, and is not matching with header length of : ${headerLength}`;
        }
        break;
      }
      message = this.validateDataCells(
        data,
        headerData,
        uploadDataSource,
        uploadAlternateDataSource
      );
      if (message) {
        break;
      }
    }
    return message;
  }

  validateDataCells(
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    data: any,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    headerData: any,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    uploadDataSource: any,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    uploadAlternateDataSource: any
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  ): any {
    let message = null;
    for (let i = 0; i < data.length; i++) {
      const headerItem = headerData[i];
      this.columnName = headerItem;
      let validateObj = find(uploadDataSource.default, ['name', headerItem]);
      if (!validateObj) {
        validateObj = find(uploadAlternateDataSource.default, ['name', headerItem]);
      }
      const validateType = validateObj.type;
      const validateParam = validateObj.parameter;
      message = this.validateMandatoryData(validateParam, data[i], validateType);
      if (message) {
        break;
      }
    }
    return message;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  validateMandatoryData(validateParam: any, columnData: any, validateType: any): any {
    let message = null;
    if (validateParam === 'mandatory' && !columnData) {
      message = `Line number ${this.lineNo} with column name ${this.columnName} should not empty value`;
      return message;
    } else if (columnData) {
      return this.validateBasedOnType(validateType, columnData);
    }
    return message;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  validateBasedOnType(dataType: any, dataValue: any): any {
    let message = null;
    switch (dataType) {
      case 'string': {
        if (typeof dataValue !== 'string') {
          message = `Line number ${this.lineNo} with column name ${this.columnName} contains value ${dataValue} is not valid`;
        }
        break;
      }
      case 'number': {
        if (isNaN(dataValue) || typeof dataValue !== 'number') {
          message = `Line number ${this.lineNo} with column name ${this.columnName} contains value ${dataValue} is not valid number`;
        }
        break;
      }
      case 'subnet': {
        if (!this.validateSubnet(dataValue)) {
          message = `Line number ${this.lineNo} with column name ${this.columnName} contains value ${dataValue} is not valid subnet`;
        }
        break;
      }
      default:
    }
    return message;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  validateSubnet(dataValue: any): boolean {
    const rangeRegEx = new RegExp(CommonRegEx.RANGE_IP4_IP6_STR);
    const ip4RegEx = new RegExp(CommonRegEx.IP4_STR);
    const ip6RegEx = new RegExp(CommonRegEx.IP6_STR);
    if (dataValue !== undefined && dataValue !== null) {
      return (
        CommonRegEx.IP_V4_CIDR.test(dataValue) ||
        CommonRegEx.IP_V6_CIDR.test(dataValue) ||
        rangeRegEx.test(dataValue) ||
        ip4RegEx.test(dataValue) ||
        ip6RegEx.test(dataValue)
      );
    } else {
      return false;
    }
  }
}
